module.exports = __webpack_public_path__ + "img/logo2-2.2d457b8f.png";